<div class="container home-container">
  @for(patient of patients$ | async; track patient.rettxid; let i = $index) {
    <div class="col12 mb-3">
      <patient-item-list [patient]="patient"></patient-item-list>
    </div>
  }
  @empty {
    <div class="d-flex justify-content-center align-items-center">
      <div class="text-center">
        <div class="icon-container">
          <i class="far fa-address-card"></i>
        </div>
        <p class="text-muted">{{ 'HOME.NO_DATA' | translate}}</p>
      </div>
    </div>
  }
</div>

<!-- Add Patient Button -->
<div class="d-flex justify-content-center align-items-center p-3 w-100">
  <button class="btn btn-rettx-primary" (click)="addNewPatient()">
    <i class="fa-solid fa-circle-plus me-2"></i>{{ 'HOME.ADD_PATIENT' | translate}}
  </button>
</div>